import { Link } from "react-router-dom";

type ResourceHunterTab = "today" | "history" | "trends";

interface ResourceHunterTabsProps {
  activeTab: ResourceHunterTab;
}

export function ResourceHunterTabs({ activeTab }: ResourceHunterTabsProps) {
  return (
    <section className="page-subnav">
      <div className="content-wrapper">
        <ul
          className="nav secondary-tabs"
          aria-label="Resource Hunter navigation"
        >
          <li className="nav-item">
            <Link
              className={`nav-link ${activeTab === "today" ? "active" : ""}`}
              to="/resource-hunter"
            >
              Today
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${activeTab === "history" ? "active" : ""}`}
              to="/resource-hunter/history"
            >
              History
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${activeTab === "trends" ? "active" : ""}`}
              to="/resource-hunter/zones"
            >
              Trends
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
}
